import { useState } from 'react'
import { submitBrandSuggestion } from '../api'
import { useAuth } from '../context/AuthContext'
import './SuggestBrandModal.css'

export default function SuggestBrandModal({ initialBrandName = '', onClose }) {
    const { user } = useAuth()
    const [brandName, setBrandName] = useState(initialBrandName)
    const [reason, setReason] = useState('')
    const [submitting, setSubmitting] = useState(false)
    const [done, setDone] = useState(false)
    const [error, setError] = useState('')

    const handleSubmit = async () => {
        if (!brandName.trim()) {
            setError('Please enter a brand name.')
            return
        }
        setSubmitting(true)
        setError('')
        try {
            await submitBrandSuggestion({
                brandName: brandName.trim(),
                reason: reason.trim(),
                userId: user?.id || null,
                userEmail: user?.email || null,
            })
            setDone(true)
        } catch (e) {
            setError('Something went wrong. Please try again.')
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <div className="suggest-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
            <div className="suggest-modal">
                <div className="suggest-header">
                    <span className="suggest-title">Suggest a brand</span>
                    <button className="suggest-close" onClick={onClose}>×</button>
                </div>

                {!user ? (
                    <div className="suggest-body">
                        <p className="suggest-signin">Sign in to suggest a brand for the index.</p>
                    </div>
                ) : done ? (
                    <div className="suggest-body">
                        <p className="suggest-success">Thank you for submitting a suggestion. We'll review the brand for index inclusion.</p>
                        <button className="suggest-btn" onClick={onClose}>Done</button>
                    </div>
                ) : (
                    <div className="suggest-body">
                        <div className="suggest-field">
                            <label className="suggest-label">Brand name</label>
                            <input
                                className="suggest-input"
                                type="text"
                                placeholder="e.g. Corridor NYC"
                                value={brandName}
                                onChange={e => setBrandName(e.target.value)}
                                autoFocus
                            />
                        </div>
                        <div className="suggest-field">
                            <label className="suggest-label">Optional — share some things about the brand</label>
                            <textarea
                                className="suggest-textarea"
                                placeholder="What makes it worth adding? Where is it from? What's the vibe?"
                                value={reason}
                                onChange={e => setReason(e.target.value)}
                                rows={3}
                            />
                        </div>
                        {error && <p className="suggest-error">{error}</p>}
                        <div className="suggest-actions">
                            <button className="suggest-cancel" onClick={onClose}>Cancel</button>
                            <button
                                className="suggest-btn"
                                onClick={handleSubmit}
                                disabled={submitting || !brandName.trim()}
                            >
                                {submitting ? 'Submitting...' : 'Submit suggestion'}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
